"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[159],{

/***/ 37649:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ popular_facets_sections)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./src/components/cards-carousel/carousel-context.tsx
var carousel_context = __webpack_require__(22556);
// EXTERNAL MODULE: ./src/components/cards-carousel/index.tsx + 9 modules
var cards_carousel = __webpack_require__(7183);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(58912);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/popular-facets/popular-facets-section.tsx




var PopularFacetsSection = function(param) {
    var title = param.title, url = param.url, products = param.products, linkText = param.linkText, negativeMargin = param.negativeMargin;
    return /*#__PURE__*/ react.createElement(carousel_context/* CarouselContextContainer */.L, {
        items: products,
        linkTitle: linkText,
        linkPath: url,
        negativeMargin: negativeMargin,
        onHeaderLinkClick: function(param) {
            var link = param.link;
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.POPULAR_FACETS_HEADER */.U.POPULAR_FACETS_HEADER,
                nextPage: link
            });
        },
        onCardClick: function(param) {
            var index = param.index, link = param.link;
            (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.POPULAR_FACETS_PRODUCT_CARD */.U.POPULAR_FACETS_PRODUCT_CARD,
                nextPage: link,
                index: index
            });
        },
        title: title
    }, /*#__PURE__*/ react.createElement(cards_carousel/* CardsCarousel */.T, null));
};

;// CONCATENATED MODULE: ./src/areas/landing-page/components/popular-facets/popular-facets-sections.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


/// make loadable
var PopularFacetsSections = function(param) {
    var popularFacets = param.popularFacets;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, popularFacets.map(function(popularFacet) {
        return /*#__PURE__*/ react.createElement(PopularFacetsSection, _extends({
            key: popularFacet.url
        }, popularFacet));
    }));
};
/* harmony default export */ const popular_facets_sections = (PopularFacetsSections);


/***/ })

}]);